<template>
  <div style="display: flex;flex-direction: column">
    <cargo-advance-select
      :select-type="TYPE_NAMES.basic_data_CargoInformation"
      :default-value="job.cargoCode"
      v-bind="$attrs"
      @parentCallBack="onParentCallBack"
    />
    <el-input v-model="job.cargoName" :disabled="disabled || !job.cargoCode" @change="onChange('cargoName')" />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'AeBasicCargoCode',
  components: { cargoAdvanceSelect },
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      TYPE_NAMES
    }
  },
  methods: {
    onParentCallBack(data) {
      this.job.cargoCode = data.value
      this.job.cargoName = data.englishName || ''
      this.$emit('childrenChange', [{ key: 'cargoCode', value: this.job.cargoCode }, { key: 'cargoName', value: this.job.cargoName }])
    },
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>
